/* eslint-disable react/prop-types,import/prefer-default-export,
no-undef,no-restricted-globals,no-console */
import React from 'react';
import { ApolloProvider } from 'react-apollo';

import CartState from './src/components/ShoppingCart/CartState';
import 'typeface-open-sans';

import ApolloClient from './src/apollo/ApolloClient';
import AgeVerificationModal, { AGE_VERIFICATION_MODAL } from './src/components/AgeVerificationModal';
import './src/utils/firebaseAuth';

const wrapRootElement = ({ element }) => (
    <ApolloProvider client={ApolloClient}>
        <CartState>
            {element}
            {
                !location.pathname.startsWith('/under-age')
                    && localStorage.getItem(AGE_VERIFICATION_MODAL) !== 'true'
                    && (
                        <AgeVerificationModal />
                    )
            }
        </CartState>
    </ApolloProvider>
);
export { wrapRootElement };
